var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1115_2414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9079 2.32895C13.8263 2.02748 13.6672 1.75264 13.4463 1.5318C13.2255 1.31095 12.9507 1.15182 12.6492 1.07023C11.5455 0.769226 7.10366 0.769226 7.10366 0.769226C7.10366 0.769226 2.66154 0.778337 1.55788 1.07934C1.25641 1.16093 0.981568 1.32008 0.760735 1.54093C0.539902 1.76178 0.380779 2.03664 0.299211 2.33811C-0.0346224 4.29911 -0.164122 7.28723 0.308378 9.16978C0.389954 9.47125 0.549081 9.74609 0.769914 9.96693C0.990746 10.1878 1.26558 10.3469 1.56704 10.4285C2.67071 10.7295 7.11271 10.7295 7.11271 10.7295C7.11271 10.7295 11.5547 10.7295 12.6583 10.4285C12.9597 10.3469 13.2346 10.1878 13.4554 9.96694C13.6763 9.7461 13.8354 9.47126 13.917 9.16978C14.2691 7.206 14.3776 4.21973 13.9079 2.32895Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68982 7.88347L9.37471 5.74914L5.68982 3.61481V7.88347Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1115_2414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.2222,
    height: 10,
    fill: "white",
    transform: "translate(0 0.769226)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.74b4c0fd15e22b539623a5a874ea7a5b.svg";
export { ForwardRef as ReactComponent };